import {UI} from "stem-core/ui/UIBase";
import {LoadingSpinner} from "../../../../core/ui/LoadingSpinner.jsx";
import {ConfirmationModal} from "../../../../blinkpay/ui/ConfirmationModal.jsx";
import {CreateLegalEntityForm} from "./CreateLegalEntityForm.jsx";


export class CreateLegalEntityModal extends ConfirmationModal {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: "Create Legal Entity",
            confirmAction: () => this.createLegalEntity(),
        }
    }

    async createLegalEntity() {
        const isFormValid = this.createLegalEntityForm && this.createLegalEntityForm.validateInputs();
        if (!isFormValid) {
            return;
        }

        await this.makeRequest("/admin/legal_entities/create", this.createLegalEntityForm.getInputValues());
    }

    render() {
        return [
            <CreateLegalEntityForm ref="createLegalEntityForm"/>,
            this.waitingForResponse && <LoadingSpinner />,
        ]
    }
}
